export default class EdgeStackDeploymentTypeSelectorController {
  /* @ngInject */
  constructor() {
    this.deploymentOptions = [
      { id: 'deployment_compose', icon: 'fab fa-docker', label: 'Compose', description: 'Формат docker-compose', value: 0 },
      {
        id: 'deployment_kube',
        icon: 'fa fa-cubes',
        label: 'Kubernetes',
        description: 'Формат манифеста Kubernetes',
        value: 1,
        disabled: () => {
          return this.hasDockerEndpoint();
        },
        tooltip: () => {
          return this.hasDockerEndpoint() ? 'Этот параметр недоступен для Edge-окружений Docker' : '';
        },
      },
    ];
  }
}
